// libs
import React, { memo } from 'react';
import DomainConfigContext from './context';

// hooks
import { useRemoteConfig } from 'shared/store/remoteConfigs/hooks';

// helpers
import { getDomainConfig } from 'shared/domainConfig/helpers';

interface DomainContextProvider {
  children: React.ReactNode;
}

function Provider({ children }: DomainContextProvider) {
  const domainConfigWithDefaults = getDomainConfig();
  const enableFEMigration = useRemoteConfig('enableFEMigration');

  domainConfigWithDefaults.SHOULD_USE_FE_API_V2 = enableFEMigration;

  return (
    <DomainConfigContext.Provider value={domainConfigWithDefaults}>
      {children}
    </DomainConfigContext.Provider>
  );
}

export default memo(Provider);
